/*
 * @Description: 
 * @Author: kai.zhou
 * @Date: 2021-01-27 21:43:08
 * @LastEditors: Mayer
 * @LastEditTime: 2024-03-19 21:15:23
 */
/*
 * @Description: 
 * @Author: kai.zhou
 * @Date: 2021-01-27 21:40:56
 * @LastEditors: kai.zhou
 * @LastEditTime: 2021-01-27 21:42:00
 */
/**
 *
 * native结果数据返回格式:
{
    code: 0,
    msg: 'success',
    "requsetCode": 123
    data: {}
}
code: 0成功，1失败
msg: 提示消息
data: 返回数据
requsetCode: 请求码，区分同一方法


 协定协议:jsbridge://carlcare.transsion.com:1234/showToast?params={"message":"hello"};
 1234: 请求码，区分同一方法；
 showToast: Native 方法
 params: 请求参数，json字符串
 */
 var win = window;
 var ua = win.navigator.userAgent;
 var JS_BRIDGE_PROTOCOL_SCHEMA = "jsbridge";
 var JS_BRIDGE_PROTOCOL_HOST = "carlcare.transsion.com";
 var JsBridge = win.JsBridge || (win.JsBridge = {});
 
 var ExposeMethod = {
   callMethod: function (method, requestCode, param, callback, fail) {
     if (typeof callback !== "function") {
       callback = null;
     }
     PrivateMethod.registerCallback(requestCode, callback);
     PrivateMethod.callNativeMethod(method, requestCode, param, fail);
   },
 
   onComplete: function (requestCode, result) {
     PrivateMethod.onNativeComplete(requestCode, result);
   },
 };
 
 var PrivateMethod = {
   callbacks: {},
   registerCallback: function (requestCode, callback) {
     if (callback) {
       PrivateMethod.callbacks[requestCode] = callback;
     }
   },
   getCallback: function (requestCode) {
     var call = {};
     if (PrivateMethod.callbacks[requestCode]) {
       call.callback = PrivateMethod.callbacks[requestCode];
     } else {
       call.callback = null;
     }
     return call;
   },
   unRegisterCallback: function (requestCode) {
     if (PrivateMethod.callbacks[requestCode]) {
       delete PrivateMethod.callbacks[requestCode];
     }
   },
   onNativeComplete: function (requestCode, result) {
     var resultJson = PrivateMethod.str2Json(result);
     var callback = PrivateMethod.getCallback(requestCode).callback;
     PrivateMethod.unRegisterCallback(requestCode);
     if (callback) {
       callback && callback(resultJson);
     }
   },
   str2Json: function (str) {
     if (str && typeof str === "string") {
       try {
         return JSON.parse(str);
       } catch (e) {
         return {
           code: 1,
           msg: "params parse error!",
         };
       }
     } else {
       return str || {};
     }
   },
   json2Str: function (param) {
     if (param && typeof param === "object") {
       return JSON.stringify(param);
     } else {
       return param || "";
     }
   },
   callNativeMethod: function (method, requestCode, param, fail) {
     if (PrivateMethod.isAndroid()) {
       var jsonStr = PrivateMethod.json2Str(param);
       var uri =
         JS_BRIDGE_PROTOCOL_SCHEMA +
         "://" +
         JS_BRIDGE_PROTOCOL_HOST +
         ":" +
         requestCode +
         "/" +
         method +
         "?params=" +
         jsonStr;
       // win.prompt(uri, "");
       //window.location.href = uri;
       if (ua.toLowerCase().indexOf("carlcareapph5") > -1) {
         //CarlCareAppH5
         window.location.href = uri;
       } else {
         if (fail) {
           fail();
         }
       }
     } else {
       if (fail) {
         fail();
       }
     }
   },
   isAndroid: function () {
     var tmp = ua.toLowerCase();
     var android = tmp.indexOf("android") > -1;
     return !!android;
   },
   isIos: function () {
     var tmp = ua.toLowerCase();
     var ios = tmp.indexOf("iphone") > -1;
     return !!ios;
   },
 };
 for (var index in ExposeMethod) {
   if (ExposeMethod.hasOwnProperty(index)) {
     if (!Object.prototype.hasOwnProperty.call(JsBridge, index)) {
       JsBridge[index] = ExposeMethod[index];
     }
   }
 }
 
 class APPJS{
   // 返回promise对象--- 获取carlcare app状态：版本号，当前用户选择国家码，用户手机号以及afid四项数据
   async userinfo(){
     let resData={
       appVersion:'',
       mcc:'',
       afid:'',
       phone:'',
       gaid:'',
       token:"",
     };
    //  resData={
    //     appVersion:'v5.8.2',
    //     mcc:'621',
    //     afid:'afid123',
    //     phone:'19888131190',//123nha
    //     gaid:'gaid123',
    //     token:"eyJhbGciOiJSUzI1NiJ9.eyJ1c2VyIjoidzZJbXlaUjNCaEdxK0tMWkZseVJhNWZtOU5LNlI3TkM2VUh3b0hlSE0yR0dMUDJUM0Npazk5ZXhaSDY0WXRMTEF2eFhYSUlvSzlIS1lQNjVFMjdkM1IvVVo3N2tsNW5Wb1Brc2Z1ZlNPcjdxVmNtY0tVZjdRTEFzT1FuNlB4aTlORUtDbW1tTksvMG1sOE9FU04wMCttM3ROR3NsUEsyeHNOQld5SUZicDF4MzNDLzlyY29Ga2l6bm1yQnNjSlVib0dlRzhrTDJPUk1BTy8rcS8yN0JXYS9aNEVkeDBXUCtXb2QrRzlVQk54cUYzNlNPNzNEcWhuU0hQS29zcENrVTdEZWRvKy9DSVc0WU94TXVKeHRoNFE9PSIsImFwcElkIjoiY2FybGNhcmVhcHAiLCJzY29wZSI6IlNjb3BlLkFMTCIsImlzcyI6InhuIiwiaWF0IjoxNjkwMjU0MTAwLCJzdWIiOiJyZWZyZXNoVG9rZW4iLCJleHAiOjE2OTgwMzAxMDB9.TFa3ZS5M7N0rR5NQACxM6XUsThci-k5rm4MLcK5br0jLLGNIUbsyH8ji4Jz8SqfcOV_KoBBzLbBpHk_FCK21sQkXEC45bBn-pjj0jV98i-uy1pzCUnnoAipUKOoM3ymYdsuZVCHqpS32Z8ZDulM1L-hcqVcxa5yqjReAnMDQsbXQ2yS46afBdlzVDGe4Emgk7mJCfmsHDbQ0hkdPzp4Ixim8Tktzn0Y4jFyBGBbAOEaH5T304WvU8xMw95Rfe0Gj_d_PsHYFu89a1u6KMeTpZ8-YRSjSAz8ysrIVbx6Tk7kXFQSeegrV2eeDikvOg6wwiPeW3OCI6s-ZaKN_t9lhgg",
    //  };
     let res=await new Promise((resolve)=>{
       // 校验是否在app内部
       JsBridge.callMethod(
         "getAppInfo",
         12345,
         {},
         function (msg) {
           if ((msg.code === "0" || msg.code === 0) && msg.data.appVersion.slice(1) >= "5.7.0.2") {
             resData.appVersion=msg.data.appVersion;
             resData.mcc=msg.data.mcc;
             resData.gaid=msg.data.gaid||'';
             JsBridge.callMethod("getLoginInfo", 123, {}, function (msg1) {
               if (msg1.code === "0" || msg1.code === 0) {
                 if (!!msg1.data.openId) {
                 resData.afid=msg1.data.openId;
                 resData.phone=msg1.data.phone;
                 resData.token=msg1.data.token;
                 }
               }
              //  localStorage.setItem("afid",msg1.data.openId)
               resolve(resData)
             },function(){
               resolve(resData)
             });
           }
         },function(){
           resolve(resData)
         }
       );
     })
     return res
   }
   // 登录功能 ------carlcare弹出登录界面，成功登录后返回用户手机号和Afid 两项数据（promise）
   async userLogin(parm={}){
     let resData={
       afid:'',
       phone:''
     };
     let res=await new Promise((resolve)=>{
       JsBridge.callMethod("login", 123, parm, function (msg) {
         if (+msg.code === 0) {
           if (!!msg.data.openId) {
             resData.afid=msg.data.openId;
             resData.phone=msg.data.phone;
           }
         }
         resolve(resData)
       },function(){
         resolve(resData)
       });
     })
     return res
   }
   //分享功能----text分享的链接或内容
   async share(text,sucFun){
     JsBridge.callMethod("shareCustomH5", 123, {
       "link":encodeURIComponent(text)
     }, function (msg) {
       if (+ msg.code === 0) {
         sucFun();//成功回调
       }
     })
   }
   // 查看定位是否开启
  async hasLocationPermission() {
    /**
     * jsbridge://carlcare.transsion.com:123/hasLocationPermission
     * <p/>
     * response: {"code":0,"data":{"has":true,"permission":"android.permission.ACCESS_FINE_LOCATION"},"requestCode":123}
     */
    let resData=false;
    let res=await new Promise((resolve)=>{
    JsBridge.callMethod("hasLocationPermission", 123, {}, function (msg) {
      if (+msg.code === 0) {
        resData=msg.data
      }
      resolve(resData)
      }, function () {
        resolve(resData)
      })
    })
    return res;
  }
  // 开启定位
  async requestLocationPermission() {
    /**
     * jsbridge://carlcare.transsion.com:123/hasLocationPermission
     * <p/>
     * response: {"code":0,"data":{"has":true,"permission":"android.permission.ACCESS_FINE_LOCATION"},"requestCode":123}
     */
    let resData=false;
    let res=await new Promise((resolve)=>{
      JsBridge.callMethod("requestLocationPermission", 123, {}, function (msg) {
          if (+msg.code === 0) {
            resData=msg.data
          }
          resolve(resData)
        }, function () {
          resolve(resData)
        })
      })
      return res;
    }
    // 新的定位方式
  async requestLocation() {
    /**
     * jsbridge://carlcare.transsion.com:123/hasLocationPermission
     * <p/>
     * response: {"code":0,"data":{"has":true,"permission":"android.permission.ACCESS_FINE_LOCATION"},"requestCode":123}
     */
    let resData=false;
    let res=await new Promise((resolve)=>{
      JsBridge.callMethod("requestLocation", 101, {}, function (msg) {
          if (+msg.code === 0) {
            resData=msg.data
          }
          resolve(resData)
        }, function () {
          resolve(resData)
        })
      })
      return res;
    }
 }
 export default new APPJS();